import { generateRandomId, getEnvironment, getLocalKlimVar, isImpersonating, setLocalKlimVar, trackMixpanel } from "utils";

const initFBSDK = () => {
  const script = document.createElement("script");
  script.src = "https://connect.facebook.net/en_US/sdk.js";
  script.referrerpolicy = "origin";
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  window.fbAsyncInit = function () {
    window.FB.init({
      appId: "410760340429351",
      xfbml: true,
      version: "v12.0",
    });
    window.FB.AppEvents.logPageView();
  };
};

const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_ID;

const initGoogleTagManager = () => {
  // Google Tag Manager setup
  const w = window;
  const d = document;
  const s = "script";
  const l = "dataLayer";
  const i = GTM_CONTAINER_ID;
  w[l] = w[l] || [];
  w[l].push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  // Create and insert the GTM script tag as the first script in the head
  const head = d.getElementsByTagName("head")[0];
  const j = d.createElement(s);
  const dl = l !== "dataLayer" ? `&l=${l}` : "";
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;

  // Find the first script tag in the head and insert the GTM script before it
  const scriptsInHead = head.getElementsByTagName(s);
  if (scriptsInHead.length > 0) {
    head.insertBefore(j, scriptsInHead[0]);
  } else {
    head.appendChild(j);
  }

  // Google Tag Manager (noscript) setup
  const noscript = d.createElement("noscript");
  const iframe = d.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${i}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";

  noscript.appendChild(iframe);

  // Insert the noscript tag as the first element in the body
  const body = d.getElementsByTagName("body")[0];

  if (body.childNodes.length > 0) {
    body.insertBefore(noscript, body.firstChild);
  } else {
    body.appendChild(noscript);
  }
};

export const INTERNAL_EMAIL_PATTERN = /@klim\.eco|klim\.test\.emails/i;
const INTERNAL_TRAFFIC_KEY = "internalTraffic";

// The Google tag runs only Arguments objects from the dataLayer. A plain object or a rest-params array never reaches GA4.
const tagInternalTraffic = () => {
  window.dataLayer = window.dataLayer || [];
  (function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  })("set", { traffic_type: "internal" });
};

// GA4 drops hits with traffic_type=internal. During impersonation, the email is the farmer's, so we tag the session from the impersonation flag.
export const markInternalTraffic = (email) => {
  const internal = isImpersonating() || INTERNAL_EMAIL_PATTERN.test(email ?? "");
  setLocalKlimVar(INTERNAL_TRAFFIC_KEY, internal);
  if (internal) tagInternalTraffic();
};

export const initAnalytics = () => {
  const env = getEnvironment();
  sessionStorage.setItem("Mixpanel_session", false);

  // we want to always init tracking/cookies in the app
  // on web, only init tracking/cookies users who have accepted cookies

  if (env.app) {
    document.addEventListener("deviceready", () => {
      initFBSDK();
    });
  }

  // The Google tags fire at Consent Initialization, before /users/me answers. So we tag from the value we stored on the last user load.
  if (isImpersonating() || getLocalKlimVar(INTERNAL_TRAFFIC_KEY)) tagInternalTraffic();
  initGoogleTagManager();

  if (env.production || env.staging) {
    if (!getLocalKlimVar("sessionId")) {
      setLocalKlimVar("sessionId", generateRandomId());
    }
    trackMixpanel("StartSession");
  }
};
